import { SkapaElement } from "@ingka/skapa-webc-element";
import { Fieldset } from "@ingka/fieldset-webc/passive.js";
const styles = ':host{--skapa-checkbox-label:rgb(var(--colour-text-and-icon-2,72,72,72));--skapa-checkbox-background:rgb(var(--colour-neutral-1,255,255,255));--skapa-checkbox-background-checked:rgb(var(--colour-interactive-emphasised-bg-default,0,88,163));--skapa-checkbox-background-checked-hover:rgb(var(--colour-interactive-emphasised-bg-hover,0,79,147));--skapa-checkbox-background-active:rgb(var(--colour-interactive-emphasised-bg-pressed,0,62,114));--skapa-checkbox-border:rgb(var(--colour-interactive-subtle-border-default,146,146,146));--skapa-checkbox-border-hover:rgb(var(--colour-interactive-subtle-border-hover,17,17,17));--skapa-checkbox-border-checked:rgb(var(--colour-interactive-emphasised-bg-default,0,88,163));--skapa-checkbox-border-checked-hover:rgb(var(--colour-interactive-emphasised-bg-hover,0,79,147));--skapa-checkbox-border-active:rgb(var(--colour-interactive-emphasised-bg-pressed,0,62,114));--skapa-checkbox-tick-colour:#0000;font-size:.875rem;line-height:1.571}:host([subtle]){--skapa-checkbox-background-subtle:rgb(var(--colour-interactive-primary-bg-default,17,17,17));--skapa-checkbox-background-subtle-hover:rgb(var(--colour-interactive-primary-bg-hover,51,51,51))}.container{column-gap:var(--skapa-input-group-column-gap,1rem);display:grid;grid-template-columns:1.5rem 1fr;position:relative;row-gap:var(--skapa-input-group-row-gap,1.5rem)}:host([disabled]){--skapa-checkbox-disabled:rgb(var(--colour-interactive-disabled-1,204,204,204));--skapa-checkbox-tick-colour:#0000;pointer-events:none}:host([disabled]) ::slotted(input:checked),:host([disabled]) ::slotted(input:indeterminate){--skapa-checkbox-tick-colour:rgb(var(--colour-interactive-disabled-2,146,146,146))}::slotted(input),::slotted(label){cursor:pointer}::slotted(input[type=checkbox]:focus-visible){box-shadow:0 0 0 4px var(--skapa-focus-ring-internal,rgb(var(--colour-neutral-1,255,255,255)));outline:2px solid var(--skapa-focus-ring-external,rgb(var(--colour-neutral-7,17,17,17)));outline:2px solid rgb(var(--colour-neutral-7,17,17,17))!important;outline-offset:4px;transition:outline .2s ease-out,box-shadow .2s ease-out}::slotted(input){-webkit-appearance:none;appearance:none;background-color:var(--skapa-checkbox-background);border:.0625rem solid var(--skapa-checkbox-disabled,var(--skapa-checkbox-border))!important;border-radius:.25rem;box-sizing:border-box;display:block;height:1.5rem;margin:0;margin-inline-end:1rem;position:relative;width:1.5rem}::slotted(input):after{border:.125rem solid var(--skapa-checkbox-tick-colour,#0000)!important;border-right:none!important;border-top:none!important;box-sizing:border-box;content:"";display:block;height:.40625rem;left:.375rem;margin-top:-.0625rem;position:absolute;top:.46875rem;transform:rotate(-45deg);transition:opacity .1s cubic-bezier(.4,0,.4,1);transition-property:border-color,opacity;width:.663125rem}::slotted(input:indeterminate):after{border-left-width:0;height:0;top:.6875rem;transform:rotate(0)}::slotted(input:hover:not([disabled])){--skapa-checkbox-border:var(--skapa-checkbox-border-hover);--skapa-checkbox-tick-colour:rgb(var(--colour-neutral-3,223,223,223))}::slotted(input:checked),::slotted(input:indeterminate){--skapa-checkbox-border:var(--skapa-checkbox-background-subtle,var(--skapa-checkbox-border-checked));--skapa-checkbox-background:var(--skapa-checkbox-disabled,var(--skapa-checkbox-background-subtle,var(--skapa-checkbox-background-checked)));--skapa-checkbox-tick-colour:rgb(var(--colour-neutral-1,255,255,255))}:host(:not([subtle])) ::slotted(input:checked),:host(:not([subtle])) ::slotted(input:indeterminate){--skapa-checkbox-tick-colour:rgb(var(--colour-static-white,255,255,255))}::slotted(input:checked:hover:not([disabled])),::slotted(input:indeterminate:hover:not([disabled])){--skapa-checkbox-border:var(--skapa-checkbox-background-subtle-hover,var(--skapa-checkbox-border-checked-hover));--skapa-checkbox-background:var(--skapa-checkbox-disabled,var(--skapa-checkbox-background-subtle-hover,var(--skapa-checkbox-background-checked-hover)));--skapa-checkbox-tick-colour:rgb(var(--colour-neutral-1,255,255,255))}:host(:not([subtle])) ::slotted(input:checked:hover:not([disabled])),:host(:not([subtle])) ::slotted(input:indeterminate:hover:not([disabled])){--skapa-checkbox-tick-colour:rgb(var(--colour-static-white,255,255,255))}::slotted(input:active:not([disabled])){--skapa-checkbox-border:var(--skapa-checkbox-background-subtle,var(--skapa-checkbox-border-active));--skapa-checkbox-background:var(--skapa-checkbox-background-subtle,var(--skapa-checkbox-background-active))}::slotted(input):before{box-sizing:border-box;content:"";cursor:pointer;height:2.75rem;margin:-.6875rem;position:absolute;width:2.75rem;z-index:2}::slotted(label){color:var(--skapa-checkbox-disabled,var(--skapa-checkbox-label));display:inline-block;line-height:1.571}@media (forced-colors:active){:host([disabled]){--skapa-checkbox-disabled:GrayText}}';
const lightStylesRaw = 'skapa-checkbox-group>input:disabled,skapa-checkbox-group>input:disabled+label{--skapa-radio-button-disabled:rgb(var(--colour-interactive-disabled-1,204,204,204));--skapa-checkbox-disabled:rgb(var(--colour-interactive-disabled-1,204,204,204));color:rgb(var(--colour-interactive-disabled-1,204,204,204));pointer-events:none}@media (forced-colors:active){skapa-checkbox-group>input:disabled,skapa-checkbox-group>input:disabled+label{--skapa-radio-button-disabled:GrayText;--skapa-checkbox-disabled:GrayText;color:GrayText}}skapa-checkbox-group>label>skapa-caption{color:rgb(var(--colour-text-and-icon-2,72,72,72));color:rgb(var(--colour-text-and-icon-3,118,118,118));display:block;font-family:inherit;font-size:.75rem;line-height:1.5;padding-top:.25rem}skapa-checkbox-group[disabled]>label>skapa-caption{color:rgb(var(--colour-interactive-disabled-1,204,204,204))}';
function generateTemplate({ html, prefixReplacer }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <skapa-fieldset>
      <slot slot="group-title" name="group-title"></slot>
      <slot class="container"></slot>
      <slot slot="helper-text" name="helper-text"></slot>
    </skapa-fieldset>
    <slot name="light-styles"></slot>
  `;
  const lightNode = document.createElement("style");
  lightNode.slot = "light-styles";
  lightNode.textContent = prefixReplacer(lightStylesRaw.toString());
  return { main: template, lightStyles: lightNode };
}
class CheckboxGroup extends SkapaElement {
  constructor() {
    super();
    this.handleSlotChange = (ev) => {
      if (ev.target?.name === "light-styles")
        return;
      this.syncFieldset();
      this.syncAutoId();
    };
    this.syncFieldset = () => {
      this.fieldSet.toggleAttribute("disabled", this.disabled);
    };
    this.syncAutoId = () => {
      if (this.autoID) {
        const idPrefix = this.autoID;
        const labels = Array.from(this.querySelectorAll("label"));
        const inputs = Array.from(this.querySelectorAll("input"));
        const helper = this.querySelector(this.getPrefixedTagName("helper-text"));
        if (inputs.length && labels.length) {
          if (helper)
            helper.id = `${idPrefix}-helper`;
          inputs.forEach((input, i) => {
            if (!input.hasAttribute("type"))
              input.type = "checkbox";
            input.id = `${idPrefix}-${i}`;
            if (helper)
              input.setAttribute("aria-describedby", helper.id);
            const label = labels[i];
            if (label)
              label.setAttribute("for", input.id);
          });
        }
      }
    };
    this.gatherProperties(["subtle", "disabled", "autoID"], this);
    const templates = this.getTemplates(generateTemplate);
    const shadow = this.shadow = this.attachShadow({ mode: "open" });
    shadow.append(templates.main.content.cloneNode(true));
    this.fieldSet = shadow.querySelector(
      this.getPrefixedTagName("fieldset")
    );
    this.lightCSS = templates.lightStyles.cloneNode(true);
    this.safariFix = document.createElement("style");
    this.safariFix.slot = "light-styles";
    this.safariFix.innerHTML = "input[type=checkbox]:checked {}";
  }
  static get observedAttributes() {
    return ["disabled", "auto-id"];
  }
  connectedCallback() {
    super.connectedCallback();
    this.append(this.safariFix);
    this.syncFieldset();
    this.syncAutoId();
    this.shadow.addEventListener(
      "slotchange",
      this.handleSlotChange
    );
    this.append(this.lightCSS);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.shadow.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  attributeChangedCallback(name) {
    if (name === "disabled")
      this.syncFieldset();
    else if (name === "auto-id")
      this.syncAutoId();
  }
  get subtle() {
    return this.hasAttribute("subtle");
  }
  set subtle(value) {
    this.toggleAttribute("subtle", !!value);
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(value) {
    this.toggleAttribute("disabled", !!value);
  }
  get autoID() {
    return this.getAttribute("auto-id");
  }
  set autoID(value) {
    if (value)
      this.setAttribute("auto-id", value);
    else
      this.removeAttribute("auto-id");
  }
}
CheckboxGroup.skapaTagName = "checkbox-group";
CheckboxGroup.skapaDependencies = [Fieldset];
export {
  CheckboxGroup
};
